import repository from '@/repositories/repository'
const resource = 'suppliers'
export default {
  index ([offset = 0, limit = 1000], params) {
    return repository.get(`${resource}/offset/${offset}/limit/${limit}`, { params })
  },
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
}
